export default __webpack_public_path__ + "static/media/CRMServices360DevPro.c7703056.png";